import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IntakeSession } from '../../intake-session';

@Component({
  selector: 'app-header',
  imports: [],
  template: ` <header class="intake-header">
    <div class="intake-header__inner">
      <div class="intake-header__brand">
        <span class="material-symbols-outlined intake-header__icon">balance</span>
        <h2 class="intake-header__title">
          {{ firmName() }}
        </h2>
      </div>
    </div>
  </header>`,
  styleUrl: './header.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class Header {
  private readonly intakeSession = inject(IntakeSession);
  protected readonly firmName = this.intakeSession.firmName;
}
